import React from 'react';
import CommonSVGIcon, { Props } from '@/components/icons/CommonSVGIcon';

export default function Chevron(props: Props) {
  return (
    <CommonSVGIcon {...props} viewBox="0 0 16 16">
      <path d="M4.94 5.72665L8 8.77587L11.06 5.72665L12 6.66539L8 10.66L4 6.66539L4.94 5.72665Z"/>
    </CommonSVGIcon>
  );
}
